import AlertTrySwitchGotoAdmin from './alert-try-switch-goto-admin-container';

export default AlertTrySwitchGotoAdmin;
